import { ComboBox } from "@shared/EDS/components/ComboBox";

interface ZoomInputProps {
  readonly value: number;
  readonly onValueChange?: (value?: number) => void;
  readonly placeholder?: string;
  readonly width?: number;
  readonly style?: React.CSSProperties;
}

export function ZoomInput({
  value,
  onValueChange,
  style,
  width,
  placeholder = "100%",
}: ZoomInputProps) {
  return (
    <ComboBox
      value={value}
      onValueChange={onValueChange}
      onBlur={onValueChange}
      placeholder={placeholder}
      items={comboBoxItems}
      toNearestSelectableValue={toNearestSelectableZoomLevel}
      noBorder={true}
      style={style}
      converters={{
        format: (value?: number) => (value ? `${Math.round(value * 100)}%` : "100%"),
        fromFormatted: (str) => (str ? parseInt(str.replace("%", "")) / 100 : 1),
        equals: (a, b) => a === b,
      }}
      width={width}
      iconButtonWidth={24}
      padding={"0 0 0 16px"}
      itemStyle={"subtle"}
    />
  );
}

const comboBoxItems = [0.1, 0.25, 0.5, 1, 1.5, 2, 3];
// this method is used to find the nearest time to the selected time, so the scroll area can scroll to the correct position
const toNearestSelectableZoomLevel: (zoomLevelInt?: number) => number | undefined = (
  zoomLevelInt,
) => {
  if (!zoomLevelInt) {
    return undefined;
  }
  const nearest = comboBoxItems.reduce((prev, curr) => {
    return Math.abs(curr - zoomLevelInt) < Math.abs(prev - zoomLevelInt) ? curr : prev;
  }, 5);
  return nearest;
};
